export default __webpack_public_path__ + "static/media/rar.5512ba8e.svg";